import type { TFunction } from 'i18next';

import type { BizyPendingChatMessage } from '../store/use-bizy-pending-chat-message-store';

/**
 * Shared payload for People Browser "Let's dive in" and email `?bizy_moment=`
 * deep links so the chat turn (text, extraContext, chip) cannot drift.
 */
export function buildRecognizeMomentChatPayload({
	name,
	title,
	body,
	source,
	personId,
	avatarUrl,
	observedMomentId,
	t,
}: {
	name: string;
	title?: string | null;
	body?: string | null;
	source?: string | null;
	personId: string;
	avatarUrl?: string | null;
	observedMomentId: string;
	t: TFunction;
}): BizyPendingChatMessage {
	const momentText = (body || title || '').trim() || null;

	return {
		text: momentText ? t('personView.letsRecognizeFor', { name, moment: momentText }) : t('personView.letsRecognize', { name }),
		extraContext: {
			prompt_key: 'recognizeMoment',
			recipient_name: name,
			observed_moment: [title, body].filter(Boolean).join(' — '),
			// The moment text alone tells Bizy nothing it can act on. The id lets the
			// backend resolve what the moment cited (BIZY-784) — for a celebration,
			// the post to add on to rather than a second recognition beside it.
			observed_moment_id: observedMomentId,
			...(source ? { moment_source: source } : {}),
		},
		userNode: {
			type: 'recognize_moment',
			payload: {
				person: { id: personId, name, avatarUrl: avatarUrl ?? null },
				observedMomentId,
				moment: momentText,
			},
		},
	};
}
